// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__4xREX","footer":"ChangeClinic_footer__UJiRG"};